import React from 'react';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import { useDossierAdminContext } from 'hooks/dossierAdmin/DossierAdminContext';
import { useEnvironnement } from 'hooks/EnvironementStoreContext';

const RightSideDetailInfo = (): React.ReactElement => {
  const [{ result: dossier }] = useDossierAdminContext();
  const [{ JUSTICE_ACTIVE_BOOL }] = useEnvironnement();

  return (
    <>
      <FieldDisplay
        key="fourriere"
        label="Fourrière"
        value={dossier.raisonSociale}
        labelClass="labelAdmin"
      />
      <FieldDisplay
        key="autorite_fourriere"
        label="Autorité de fourrière"
        value={dossier.libelleComplet}
        labelClass="labelAdmin"
      />
      <FieldDisplay
        key="uniteFO"
        label="Unité FO"
        value={dossier.unite}
        labelClass="labelAdmin"
      />
      <FieldDisplay
        key="parentFO"
        label="Unité parent FO"
        value={dossier.libelleUniteFoParent}
        labelClass="labelAdmin"
        emptyMessage="Unité sans parent"
      />
      {JUSTICE_ACTIVE_BOOL && (
        <>
          <FieldDisplay
            key="juridiction"
            label="Juridiction"
            value={dossier.libelleJuridiction}
            labelClass="labelAdmin"
            emptyMessage="Aucune juridiction renseignée"
          />
          <FieldDisplay
            key="parquet"
            label="N° Parquet"
            value={dossier.numeroParquet}
            labelClass="labelAdmin"
          />
        </>
      )}
    </>
  );
};

export default RightSideDetailInfo;
